
/* ============================================
   FK U** RINGS — PAGE 2 (PRODUCT / CHECKOUT)
   Selector logic, accent system, AJAX cart add,
   image gallery, popup, expandables.
   ============================================ */

(function() {

  /* ============ STATE ============ */
  const selected = {
    character: null,
    color: null,
    size: null,
    finish: null
  };

  const page = document.querySelector('.fku2-page');
  const form = document.getElementById('fku2-form');
  const errorEl = document.getElementById('fku2-error');
  const confirmEl = document.getElementById('fku2-confirm');
  const atc = document.getElementById('fku2-atc-desktop');
  const colorNameEl = document.getElementById('fku2-color-name');

  /* ============ UPDATE FORM STATE ============ */
  function updateFormState() {
    document.getElementById('fku2-prop-character').value = selected.character || '';
    document.getElementById('fku2-prop-color').value = selected.colorLabel || selected.color || '';
    document.getElementById('fku2-prop-size').value = selected.size || '';
    document.getElementById('fku2-prop-finish').value = selected.finishLabel || selected.finish || '';
    /* Hidden English versions for merchant (underscore prefix hides from customer-facing views) */
    var enColor = document.getElementById('fku2-prop-color-en'); if (enColor) enColor.value = selected.color || '';
    var enFinish = document.getElementById('fku2-prop-finish-en'); if (enFinish) enFinish.value = selected.finish || '';

    const allFilled = selected.character && selected.color && selected.size && selected.finish;

    if (allFilled) {
      atc.disabled = false;
      errorEl.classList.add('hidden');
    } else {
      atc.disabled = true;
      errorEl.classList.remove('hidden');
    }
  }

  /* ============ CHARACTER SELECTOR ============ */
  document.querySelectorAll('.fku2-char-cell').forEach(function(cell) {
    cell.addEventListener('click', function() {
      document.querySelectorAll('.fku2-char-cell').forEach(function(c) {
        c.classList.remove('selected');
      });
      cell.classList.add('selected');
      selected.character = cell.dataset.char;
      goToSlideByKeyword('character-grid');
      updateFormState();
    });
  });

  /* ============ COLOR SELECTOR ============ */
  document.querySelectorAll('.fku2-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      document.querySelectorAll('.fku2-swatch').forEach(function(s) {
        s.classList.remove('selected');
      });
      swatch.classList.add('selected');
      selected.color = swatch.dataset.color;
      selected.colorLabel = swatch.dataset.label || swatch.dataset.color;
      colorNameEl.textContent = selected.colorLabel;
      goToSlideByKeyword('color-variants');

      /* Update CSS accent variable on the page scope */
      const hex = swatch.dataset.hex || '#C8FF00';
      page.style.setProperty('--color-accent-current', hex);
      const stars = document.getElementById('fku2-title-stars');
      if (stars) stars.style.color = hex;

      updateFormState();
    });
  });

  /* ============ SIZE SELECTOR ============ */
  document.querySelectorAll('.fku2-size').forEach(function(size) {
    size.addEventListener('click', function() {
      document.querySelectorAll('.fku2-size').forEach(function(s) {
        s.classList.remove('selected');
      });
      size.classList.add('selected');
      selected.size = size.dataset.size;
      goToSlideByKeyword('size-guide');
      updateFormState();
    });
  });

  /* ============ FINISH SELECTOR ============ */
  document.querySelectorAll('.fku2-finish').forEach(function(finish) {
    finish.addEventListener('click', function() {
      document.querySelectorAll('.fku2-finish').forEach(function(f) {
        f.classList.remove('selected');
      });
      finish.classList.add('selected');
      selected.finish = finish.dataset.finish;
      selected.finishLabel = finish.dataset.label || finish.dataset.finish;
      goToSlideByKeyword('finish-comparison');
      updateFormState();
    });
  });

  /* ============ ADD TO CART — AJAX ============ */
  function submitCart() {
    if (!selected.character || !selected.color || !selected.size || !selected.finish) return;

    const formData = new FormData(form);

    atc.disabled = true;
    atc.textContent = (window.fku2Strings && window.fku2Strings.adding) || 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      confirmEl.classList.add('show');
      updateCartCount();

      atc.textContent = (window.fku2Strings && window.fku2Strings.addToCart) || 'Add to Cart';
      atc.disabled = false;

      setTimeout(function() {
        confirmEl.classList.remove('show');
      }, 2000);
    })
    .catch(function(err) {
      atc.textContent = (window.fku2Strings && window.fku2Strings.addToCart) || 'Add to Cart';
      atc.disabled = false;
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const navCart = document.querySelector('.nav-cart');
        if (navCart) {
          if (cart.item_count > 0) {
            navCart.textContent = ((window.fku2Strings && window.fku2Strings.cart) || 'Cart') + ' (' + cart.item_count + ')';
          } else {
            navCart.textContent = (window.fku2Strings && window.fku2Strings.cart) || 'Cart';
          }
        }
      });
  }

  /* Intercept form submission */
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    submitCart();
  });

  /* ============ IMAGE GALLERY ARROWS ============ */
  const track = document.getElementById('fku2-images-track');
  const prevBtn = document.getElementById('fku2-arrow-prev');
  const nextBtn = document.getElementById('fku2-arrow-next');

  if (prevBtn && nextBtn && track) {
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
  }

  /* ============ IMAGE SWITCHING ON SELECTION ============
     Each selector jumps to an image whose alt text contains a keyword.
     Set the alt text on each image in Shopify admin (Products → FK U** RINGS
     → Images → click image → edit alt text) as follows:
       Character grid image  → alt text must contain: character-grid
       Color variants image  → alt text must contain: color-variants
       Size / hand image     → alt text must contain: size-guide
       Finish comparison     → alt text must contain: finish-comparison
     Keywords are matched case-insensitively; the rest of the alt text can be anything.
  ============================================================ */
  const galleryImgs = track ? track.querySelectorAll('.fku2-image-slide img') : [];
  var slideAltMap = {};
  galleryImgs.forEach(function(img, i) {
    if (img.alt) slideAltMap[img.alt.toLowerCase()] = i;
  });

  function goToSlide(index) {
    if (!track || index === undefined || index === null) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }

  function goToSlideByKeyword(keyword) {
    var kw = keyword.toLowerCase();
    var keys = Object.keys(slideAltMap);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf(kw) !== -1) {
        goToSlide(slideAltMap[keys[i]]);
        return;
      }
    }
    // keyword not found — do nothing silently
  }

  /* ============ SIZING POPUP ============ */
  const popup = document.getElementById('fku2-popup');
  const popupOverlay = document.getElementById('fku2-popup-overlay');
  const popupClose = document.getElementById('fku2-popup-close');
  const howToMeasure = document.getElementById('fku2-how-to-measure');

  function openPopup() {
    popup.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (howToMeasure) {
    howToMeasure.addEventListener('click', openPopup);
  }
  if (popupClose) {
    popupClose.addEventListener('click', closePopup);
  }
  if (popupOverlay) {
    popupOverlay.addEventListener('click', closePopup);
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('open')) {
      closePopup();
    }
  });

  /* ============ EXPANDABLE SECTIONS ============ */
  document.querySelectorAll('.fku2-exp-header').forEach(function(header) {
    header.addEventListener('click', function() {
      const exp = header.parentElement;
      const isOpen = exp.classList.contains('open');

      document.querySelectorAll('.fku2-exp').forEach(function(e) {
        e.classList.remove('open');
        const icon = e.querySelector('.fku2-exp-icon');
        if (icon) icon.textContent = '+';
      });

      if (!isOpen) {
        exp.classList.add('open');
        const icon = exp.querySelector('.fku2-exp-icon');
        if (icon) icon.textContent = '−';
      }
    });
  });

  /* ============ INIT ============ */
  updateFormState();

})();



